var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 33.5,
    height: 33.5,
    rx: 4.75,
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 33.5,
    height: 33.5,
    rx: 4.75,
    stroke: "#DAD8D8",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27 14V21.46C27 23.75 25.14 25.6 22.85 25.6H11.15C8.86 25.6 7 23.75 7 21.46V14H27Z",
    fill: "#DC1F5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12.54V14H7V12.54C7 10.25 8.86 8.4 11.15 8.4H22.85C25.14 8.4 27 10.25 27 12.54Z",
    fill: "#DC1F5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.25H11C10.59 22.25 10.25 21.91 10.25 21.5C10.25 21.09 10.59 20.75 11 20.75H13C13.41 20.75 13.75 21.09 13.75 21.5C13.75 21.91 13.41 22.25 13 22.25Z",
    fill: "#DC1F5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.25H15.5C15.09 22.25 14.75 21.91 14.75 21.5C14.75 21.09 15.09 20.75 15.5 20.75H19.5C19.91 20.75 20.25 21.09 20.25 21.5C20.25 21.91 19.91 22.25 19.5 22.25Z",
    fill: "#DC1F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCard);
export default __webpack_public_path__ + "static/media/default_card.3eb9bfab43927de0120fed1adf6ac198.svg";
export { ForwardRef as ReactComponent };